import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  work: null,
  loading: false,
  error: null,
  workHistory: [],
  working: false,
};
const workSlice = createSlice({
  name: "work",
  initialState,
  reducers: {
    startWork: (state, action) => {
      state.work = action.payload;
      state.working = true;
    },
    endWork: (state, action) => {
      state.work = action.payload;
      state.working = false;
    },
    setWork: (state, action) => {
      state.working = action.payload;
    },
  },
  extraReducers: (builder) => {},
});
export const { startWork, endWork, setWork } = workSlice.actions;
export default workSlice.reducer;
